import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";

const ModulesTableDescriptionCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={module.description} />
    </TableSimpleCell>
  );
};

export default ModulesTableDescriptionCell;
